export const APP_DOCUMENTS = [
  ['/planos/', 'Planos do Visual Gusto', 'Consulte os planos e as condições atuais do tutor Visual Gusto. A disponibilidade e os valores são apresentados no catálogo de planos.'],
  ['/checkout/', 'Checkout', 'Confira os dados e as condições da sua assinatura.'],
  ['/checkout/sucesso/', 'Confirmação de assinatura', 'Acompanhe a confirmação da sua assinatura.'],
  ['/checkout/cancelado/', 'Checkout cancelado', 'Revise as opções da sua assinatura.'],
  ['/conta/', 'Minha conta', 'Gerencie os dados da sua conta no VisuAlg Web.'],
  ['/conta/assinatura/', 'Minha assinatura', 'Consulte e gerencie sua assinatura.'],
  ['/jornada/', 'Minha jornada', 'Acompanhe sua jornada de aprendizagem.'],
  ['/recuperar-senha/', 'Recuperar senha', 'Solicite a recuperação da sua conta.'],
  ['/redefinir-senha/', 'Redefinir senha', 'Defina uma nova senha para sua conta.'],
  ['/backoffice/', 'Administração', 'Área de administração do VisuAlg Web.'],
  ['/cursos/', 'Cursos', 'Consulte os cursos disponíveis no VisuAlg Web.'],
  ['/cursos/meus/', 'Meus cursos', 'Acesse os cursos da sua conta.'],
  ['/termos/', 'Termos de uso', 'Consulte os termos de uso atuais do VisuAlg Web.'],
  ['/privacidade/', 'Política de privacidade', 'Consulte a política de privacidade atual do VisuAlg Web.'],
  ['/servico/', 'Condições de serviço', 'Consulte as condições atuais do serviço.'],
].map(([route, heading, description]) => ({ route, heading, title: `${heading} | VisuAlg Web`, description, noIndex: true }))

export const EDITOR_APP_PATHS = ['/', ...APP_DOCUMENTS
  .filter(page => !['/recuperar-senha/', '/redefinir-senha/', '/backoffice/'].includes(page.route))
  .map(page => page.route), '/cursos/:slug']

export const APP_REWRITES = [
  ['/backoffice/*', '/backoffice/'],
  ['/cursos/:slug', '/cursos/'],
  ['/cursos/:slug/', '/cursos/'],
]

export const DEBUG_DOCUMENTS = ['/debug-chat/', '/debug-offers/'].map(route => ({
  route, title: 'Diagnóstico | VisuAlg Web', heading: 'Diagnóstico',
  description: 'Área de diagnóstico do VisuAlg Web.', noIndex: true,
}))

export const NOT_FOUND_SEO = {
  route: '/404/', title: 'Página não encontrada | VisuAlg Web', heading: 'Página não encontrada',
  description: 'Este endereço não existe. Continue pelo editor ou escolha uma aula de lógica de programação.', noIndex: true,
}
